import React from 'react';

import {FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const DomainsSkeleton = () => (
    <FormItemSkeleton labelWidth={54}>
        <Group direction="v" gap="xs" alignItems="start">
            <SkeletonItem width={300} height={32}/>
        </Group>
        <SkeletonItem width={100} height={20}/>
    </FormItemSkeleton>
);
